import React, { useEffect, useState } from 'react';
import qs from 'query-string';
import { getPageLimit, showError, updatePageLimit } from 'utils';
import ActionButton from 'components/ActionButton';
import DataTable from 'components/DataTable';
import { tableStyles } from 'css/tableStyles';
import { deleteTag, fetchTags } from 'services/api/tags';
import styles from './index.module.scss';
import AddTagModal from 'components/AddTagModal';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import CustomLink from 'components/TableLink';

let filters: { [p: string]: any; page: number } = {
  page: 0,
  deleted: false,
};

const AvailableTags = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [tags, setTags] = useState<Record<string, any>[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [filterText, setFilterText] = useState<string>('');

  const columns = [
    {
      name: 'Id',
      selector: 'objectId',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row.objectId}
          linkTo={`/available-tags/${row.objectId}`}
        />
      ),
    },
    {
      name: 'Name',
      selector: 'value',
    },
    {
      name: 'English Name',
      selector: 'enValue',
    },
    {
      name: 'Slug',
      selector: 'slug',
    },
    {
      name: 'English Slug',
      selector: 'enSlug',
    },
    {
      name: 'Public',
      selector: 'isPublic',
      cell: row => {
        if (typeof row.isPublic !== 'undefined') {
          return <div>{row.isPublic.toString()}</div>;
        } else {
          return <div>{'N/A'}</div>;
        }
      },
    },
    {
      name: 'Action',
      selector: '',
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => (
        <div className={'ml-3'}>
          <DeleteActionForTable
            onClick={() => deletAvailableTags(row.objectId)}
          />
        </div>
      ),
    },
  ];

  const deletAvailableTags = async (id) => {
    try {
      await deleteTag(id);
      fetchAvailableTags();
    } catch (e) {
      showError(e);
    }
  };

  const fetchAvailableTags = async () => {
    setLoading(true);
    try {
      const response = await fetchTags();
      setTags(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const queryStringToFilter = () => {
    return qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });
  };

  const getTableData = () => (
    tags.filter(tag => tag.value.toLowerCase().includes(filterText.toLocaleLowerCase()))
  );

  useEffect(() => {
    filters = {
      ...filters,
      ...queryStringToFilter(),
    };
    // sort = {};
    fetchAvailableTags();
  }, []);

  const filterToQueryString = () => {
    return qs.stringify({ ...filters });
  };

  const updateQueryString = () => {
    const qs = filterToQueryString();
    props.history.push({
      pathname: props.location.pathname,
      search: qs,
    });
  };

  const onChangePage = (page: number) => {
    filters.page = page - 1;
    updateQueryString();
    fetchAvailableTags();
  };

  const onChangeRowsPerPage = (rowsPerPage: number, currentPage: number) => {
    filters.limit = rowsPerPage;
    updatePageLimit(rowsPerPage);
    onChangePage(currentPage);
  };

  return (
    <>
      {openModal &&
        <AddTagModal
          toggleModal={() => setOpenModal(!openModal)}
          onSuccess={() => fetchAvailableTags()}
        />
      }
      <div className={styles['header']}>
        <div className={styles['heading']}>Available Tags</div>
        <ActionButton
          text={<>Add Tags <span>+</span></>}
          active={true}
          isLoading={false}
          onClick={() => setOpenModal(!openModal)}
        />
      </div>
      {/* <Filter {...props} onSubmit={onFilterSubmit} /> */}
      <DataTable
        keyField="objectid"
        columns={columns}
        data={getTableData()}
        highlightOnHover={true}
        customStyles={tableStyles}
        pagination={true}
        paginationServer={true}
        title={
          <input
            type={'text'}
            placeholder={'Search tag name'}
            onChange={(e) => setFilterText(e.target.value)}
            style={{ paddingLeft: '10px' }}
          />
        }
        paginationPerPage={getPageLimit()}
        paginationDefaultPage={(filters.page || 0) + 1}
        paginationTotalRows={tags.length}
        paginationRowsPerPageOptions={[50, 100, 200]}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        loading={loading}
      />
    </>
  );
};

export default AvailableTags;